<template>
  <div>
    <div>
      <p>{{ $t('dashboard.aquisition-booster.messages.reactivateContacts') }}</p>
      <div
        v-if="!hasImportedLeads"
        class="d-flex flex-column"
      >
        <span class="text-subtitle-2 font-weight-regular">{{
          $t('dashboard.aquisition-booster.messages.importTip')
        }}</span>
        <v-btn
          variant="outlined"
          color="primary"
          :class="{
            'w-full': $vuetify.display.smAndDown,
            'small-button': $vuetify.display.mdAndUp,
          }"
          @click="handleImportClick"
        >
          {{ $t('dashboard.aquisition-booster.buttons.importContacts') }}
        </v-btn>
      </div>
      <span
        v-else
        class="text-subtitle-2 font-weight-regular"
      >
        {{ $t('dashboard.aquisition-booster.messages.alreadyImported') }}
      </span>

      <div class="d-flex flex-column mt-4">
        <span class="text-subtitle-2 font-weight-regular">
          {{ $t('dashboard.aquisition-booster.messages.reactivateWithEmails') }}
        </span>
        <v-btn
          :variant="!hasImportedLeads ? 'outlined' : undefined"
          color="primary"
          :class="{
            'w-full': $vuetify.display.smAndDown,
            'small-button': $vuetify.display.mdAndUp,
          }"
          @click="handleInviteClick"
        >
          {{ $t('dashboard.aquisition-booster.buttons.startBooster') }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import HAS_IMPORTED_LEADS from './HasImportedLeads.gql'

export default {
  methods: {
    handleInviteClick() {
      this.$tracking?.event('Dashboard', 'Clicked', 'Invite Contacts')
      this.$router.push({
        path: '/leads/list',
        query: {
          toolOpen: 'acquisition',
        },
      })
    },
    handleImportClick() {
      this.$tracking?.event('Dashboard', 'Clicked', 'Import Contacts')
      this.$router.push({
        path: '/leads/list',
        query: {
          showImportContacts: true,
        },
      })
    },
  },
  apollo: {
    hasImportedLeads: {
      query: HAS_IMPORTED_LEADS,
    },
  },
}
</script>
<style scoped>
.small-button {
  width: 300px;
}
</style>
